import { render, staticRenderFns } from "./LastMonthConsumptionWidget.global.vue?vue&type=template&id=277fb73e&lang=pug&"
import script from "./LastMonthConsumptionWidget.global.vue?vue&type=script&lang=ts&"
export * from "./LastMonthConsumptionWidget.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports